import { render, staticRenderFns } from "./TvScoreDetail.vue?vue&type=template&id=6e717915&scoped=true&"
import script from "./TvScoreDetail.vue?vue&type=script&lang=js&"
export * from "./TvScoreDetail.vue?vue&type=script&lang=js&"
import style0 from "./TvScoreDetail.vue?vue&type=style&index=0&id=6e717915&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e717915",
  null
  
)

export default component.exports